import React from 'react';
import { useEventDiscountCodes } from './useEventDiscountCodes';
import { Buttons, FormGrid, LoadingIndicator, MoreActionsMenuButton, OccupyFreeSpace, PseudoLink2, SearchField, SimpleDialog, useCopyText } from '../../../toolympus/components/primitives';
import { FormControlsForFields, TableForFields } from '../../../toolympus/components/schemed';
import { Button } from '@mui/material';
import { Add, GetAppOutlined } from '@mui/icons-material';

interface Props {
  eventId: number;
  kind?: "admin" | "coorg";
}

export const EventDiscountCodesList = (props: Props) => {
  const data = useEventDiscountCodes(props.kind || "admin", props.eventId);
  const copyText = useCopyText();

  return (
    <>
      <Buttons>
        <Button
          size="small"
          color="primary"
          startIcon={<Add />}
          onClick={() => data.batchCreate.startEditing({
            mode: "auto",
            count: 10,
            discount_amount: 1000,
            template: "{CODE}",
            codes: "",
            })}>
          create multiple codes
        </Button>

        <Button
          size="small"
          startIcon={<Add />}
          onClick={() => data.newRecord.startEditing()}>
          create single code
        </Button>

        <OccupyFreeSpace />
        <SearchField
          filter={data.filter.filter}
          setFilter={data.filter.setFilter}
          autoFocus
          noButton
          small
          />
        <Button startIcon={<GetAppOutlined />} size="small" color="primary" onClick={() => data.exportRecords()}>
          export
        </Button>
      </Buttons>

      <TableForFields
        data={data.data}
        schema={data.schema}
        fields={[
          ["actions", { label: " ", width: 35 } ],
          ["code"],
          ["discount_amount"],
          ["applied_to_registration_id"],
          ["created_at", { utcToLocal: true }],
          ["created_by"],
        ]}
        fieldElement={f => {
          if(f === "code") {
            return (row,s,orig) => <PseudoLink2 onClick={() => copyText(row.code)}>{orig}</PseudoLink2>
          }
          if(f === "actions") {
            return (row) => (
              <Buttons style={{ width: 30 }}>
                <MoreActionsMenuButton
                  actions={[
                    ["remove", `Remove`, () => data.remove.run(row)],
                  ]}
                  />
              </Buttons>
            )
          }
        }}
        />

      <SimpleDialog
        dialogTitle="Create single code"
        {...data.newRecord.dialog}
        save={() => data.newRecord.save()}>
          <FormGrid columns="1fr">
            <FormControlsForFields
              data={data.newRecord.item}
              fields={[
                ["code", { controlProps: { autoFocus: true }}],
                ["discount_amount"],
              ]}
              schema={data.schema}
              onChange={(o,c) => data.newRecord.update(c)}
              />
          </FormGrid>

      </SimpleDialog>

      <SimpleDialog
        dialogTitle="Create multiple codes"
        submitOnModEnter
        {...data.batchCreate.dialog}
        save={() => data.batchCreate.save()}>
          <FormGrid columns="1fr">
            <FormControlsForFields
              data={data.batchCreate.item}
              fields={[
                ["mode"],
                data.batchCreate.item?.mode !== "manual" ? ["count"] : null,
                ["discount_amount"],
                data.batchCreate.item?.mode === "auto" ? ["template", { controlProps: { autoFocus: true }}] : null,
                data.batchCreate.item?.mode === "manual" ? ["codes", { controlProps: { autoFocus: true }}] : null,
              ]}
              schema={data.batchSchema}
              onChange={(o,c) => data.batchCreate.update(c)}
              />
            {data.batchCreate.isLoading && <LoadingIndicator />}
          </FormGrid>

      </SimpleDialog>
    </>
  );
}
